import React, { useRef } from 'react';
import * as styles from './index.module.less';
import { MULTIPLE_LANGUAGE_RENDER_LIST } from '@/constants/multiple-language';
import { PublicArrowDownOutlined, PublicLanguage } from 'notta-web-icon';
import useDropdownPosition from '@/hooks/useDropdownPosition';

interface IProps {
  curLanguage?: string;
  showTriggerLabel?: boolean;
  atHeader?: boolean;
  renderLanguageList?: { label: string; slug: string }[];
  className?: string;
}

export const PAGE_LANGUAGE_LS_KEY = 'homepage-cur-lng';

const LanguagesSelector = ({
  curLanguage = 'en',
  showTriggerLabel = false,
  atHeader = false,
  renderLanguageList = MULTIPLE_LANGUAGE_RENDER_LIST,
  className = '',
}: IProps) => {
  let curSlug = '';
  if (curLanguage === 'ja' || curLanguage === 'jp') {
    curSlug = '';
  } else {
    curSlug = curLanguage;
  }
  const curLngInfo = renderLanguageList.find((item) => item.slug === curSlug);
  const triggerRef = useRef();
  const dropdownRef = useRef();
  const { position } = useDropdownPosition({ triggerRef, dropdownRef });

  const handleClick = (lngItem) => {
    localStorage.setItem(PAGE_LANGUAGE_LS_KEY, lngItem.slug === '' ? 'ja' : lngItem.slug);
  };

  const lngLabel = atHeader
    ? curLngInfo?.slug?.toUpperCase() === ''
      ? 'JA'
      : curLngInfo?.slug?.toUpperCase()
    : curLngInfo?.label;

  return (
    <div className={`${styles.wrapper} ${className}`}>
      <button className={styles.trigger_btn} ref={triggerRef}>
        <PublicLanguage className={styles.icon} />
        {showTriggerLabel && lngLabel}
        <PublicArrowDownOutlined className={`${styles.icon} ${styles.arrow_icon}`} />
      </button>
      <div
        className={styles.other_lng_link_wrapper}
        ref={dropdownRef}
        style={{
          left: position.left,
          right: position.right,
          top: position.top,
          bottom: position.bottom,
        }}
      >
        {renderLanguageList.map((item) => {
          return (
            <a
              href={`/${item.slug}`}
              key={item.label}
              className={styles.lng_link_item}
              onClick={() => handleClick(item)}
            >
              {item.label}
            </a>
          );
        })}
      </div>
    </div>
  );
};
export default LanguagesSelector;
